import React from 'react'
import { StyledDownloadButton } from './DownloadIcon.style'
import { IconButton } from '@wsc_sports/components-library'

interface Props {
  onClick: () => void
  isFadeIn?: boolean
}

const DownloadButton = ({ onClick, isFadeIn }: Props): JSX.Element => {
  return (
    <StyledDownloadButton onClick={onClick} isFadeIn={isFadeIn} data-type="download-button">
      <IconButton name="download" title="Download" />
    </StyledDownloadButton>
  )
}

export default DownloadButton
